<template lang="pug">
div
  Loader(v-if='renderLoader', absolute)
  .promo--merchant-list.px-4.pb-4(v-else)
    SearchBox(v-model='search', placeholder='Nama merchant')
    ListItem(
      v-for='merchant in filteredMerchantList',
      :clickable='merchant.show_merchant_stores',
      @click='clickMerchant(merchant)',
      :item='merchant',
      :key='merchant.id',
      paddingY="0"
    )
      template(v-slot:info, v-if='!isSheetEmpty(merchant)')
        p.mt-3.mb-0.promo--merchant-list__toggle(@click.stop='openSheet(merchant)') Lihat Detail
      template(v-slot:info, v-else)
        p.mt-3.mb-0.pb-4
    SlideUpSheet(:show='showSheet', v-on:close='showSheet = false')
      template(v-slot:content)
        p.promo--merchant-list__sheet-title Informasi
        .promo--merchant-list__sheet-content(v-html='sheetContent')
</template>

<script>
import { mapGetters } from 'vuex';
import { ListItem, SearchBox, Loader, SlideUpSheet, Title, Description, Section } from '@ovo/ravier-vue';
import { formatDate, formatBalance } from '../helpers/utils';
import JSBridge  from '@/helpers/jsbridge';

export default {
  components: { Loader, SearchBox, ListItem, SlideUpSheet, Title, Description, Section },
  data() {
    return {
      search: '',
      showSheet: false,
      cashbackAmount: '',
      cashbackStart: '',
      cashbackEnd: '',
      minimumTransaction: '',
    };
  },
  computed: {
    ...mapGetters({
      promoDetail: 'getPromoDetail',
      renderLoader: 'getRenderLoader',
      promoMerchants: 'getPromoMerchants',
    }),
    sheetContent() {
      let contentItems = '';
      contentItems +=
        this.cashbackAmount !== 0 || this.cashbackAmount !== ''
          ? `<li>Cashback hingga ${formatBalance(parseInt(this.cashbackAmount))} OVO Points setiap transaksi per OVO ID.</li>`
          : '';
      contentItems +=
        this.cashbackStart !== 0 || this.cashbackStart !== ''
          ? `<li>Cashback OVO Points bisa di dapatkan dari ${formatDate(this.cashbackStart.replaceAll('-','/'))} - ${formatDate(this.cashbackEnd.replaceAll('-','/'))} per OVO ID.</li>`
          : '';
      contentItems +=
        this.minimumTransaction !== 0 || this.minimumTransaction !== ''
          ? `<li>Minimal transaksi Rp${formatBalance(parseInt(this.minimumTransaction))}.</li>`
          : '';
      return `<ul>${contentItems}</ul>`;
    },
    filteredMerchantList() {
      if (this.promoMerchants) {
        return this.promoMerchants
          .filter(merchant => merchant.name.toString().toUpperCase().includes(this.search.toUpperCase()))
          .map(merchant => {
            return {
              title:
                merchant.cashback_percentage > 0
                  ? `${merchant.name} - Cashback ${merchant.cashback_percentage}%`
                  : merchant.name,
              description: merchant.all_stores ? `Tersedia di semua lokasi`
              : 'Tersedia di lokasi yang berpartisipasi',
              image: merchant.image,
              cashback_end_date: merchant.cashback_end_date,
              cashback_limit_period: merchant.cashback_limit_period,
              cashback_limit_user: merchant.cashback_limit_user,
              cashback_percentage: merchant.cashback_percentage,
              cashback_start_date: merchant.cashback_start_date,
              min_transaction: merchant.min_transaction,
              id: merchant.id,
              stores_count: merchant.stores_count,
              show_merchant_stores: merchant.show_merchant_stores,
            };
          });
      }
      return [];
    },
  },
  mounted() {
    this.setPromoMerchants();
  },
  methods: {
    async setPromoMerchants() {
      await this.$store.dispatch('getPromoMerchants', this.$route.query.id);
    },
    clickMerchant(merchant) {
      const jsBridge = new JSBridge();
      const promoEvent = {
        id: this.promoDetail.id,
        name: this.promoDetail.title,
      };
      jsBridge.leanplumWebviewTracker('event/promo_page/click_merchant', promoEvent);
      this.$router.push(`location?promo_id=${this.$route.query.id}&merchant_id=${merchant.id}`);
    },
    openSheet(merchant) {
      if (!this.isSheetEmpty(merchant)) {
        this.cashbackAmount = merchant.cashback_limit_user;
        this.minimumTransaction = merchant.min_transaction;
        this.cashbackStart = merchant.cashback_start_date;
        this.cashbackEnd = merchant.cashback_end_date;
        this.showSheet = true;
      }
    },
    isSheetEmpty(merchant) {
      return (
        (merchant.cashback_limit_user === 0 || merchant.cashback_limit_user === '') &&
        (merchant.min_transaction === 0 || merchant.min_transaction === '') &&
        (merchant.cashback_start_date === 0 || merchant.cashback_start_date === '')
      );
    },
  },
};
</script>
